import FieldType from '../../../components/Form/Fields/type'
import { length, lengthRequired, birthYear, cpf, phoneRequired, phone } from '@polvo-labs/form-utils'
import Avatar from '../../../components/Form/Fields/Avatar'
import Select from '../../../components/Form/Fields/Select'
import { cpfCnpjRequiredValidation } from '../../../utils/form-validations'

export interface UserEditFormData {
  id: number
  avatar: { id: number, url: string }
  name: string
  city: string
  phone: string
  cpf: string
  birth_year: string
  profession: string
  gender: string
}

export type UserEditForm = keyof UserEditFormData

const fields: FieldType<UserEditForm>[] = [
  {
    name: 'avatar',
    data: {},
    html: {},
    component: Avatar,
  },
  {
    name: 'name',
    data: {
      icon: 'text',
      label: 'Nome completo *',
    },
    html: {
      maxLength: 100,
      placeholder: 'Nome e sobrenome',
    },
    validation: lengthRequired({ min: 1, max: 100 }),
  },
  // {
  //   name: 'city',
  //   data: {
  //     icon: 'geolocation',
  //     label: 'Cidade atual',
  //   },
  //   html: {
  //     maxLength: 30,
  //     placeholder: 'Onde você mora?',
  //   },
  //   validation: length({ min: 1, max: 30 }),
  // },
  // {
  //   name: 'phone',
  //   data: {
  //     icon: 'phone',
  //     label: 'Telefone *',
  //   },
  //   html: {
  //     maxLength: 15,
  //     placeholder: '(xx) xxxxx-xxxx',
  //   },
  //   validation: phone,
  // },
  {
    name: 'cpf',
    data: {
      icon: 'cpf',
      label: 'CPF',
    },
    html: {
      maxLength: 18,
      placeholder: 'Informe seu CPF',
    },
    validation: cpfCnpjRequiredValidation,
  },
  // {
  //   name: 'birth_year',
  //   data: {
  //     icon: 'calendar',
  //     label: 'Ano de nascimento',
  //   },
  //   html: {
  //     maxLength: 4,
  //     pattern: '\\d\\d\\d\\d',
  //     placeholder: 'Em que ano você nasceu?',
  //   },
  //   validation: birthYear,
  // },
  // {
  //   name: 'profession',
  //   data: {
  //     icon: 'profession',
  //     label: 'Profissão',
  //   },
  //   html: {
  //     maxLength: 100,
  //     placeholder: 'Qual a sua profissão?',
  //   },
  //   validation: length({ min: 1, max: 100 }),
  // },
  // {
  //   name: 'gender',
  //   component: Select,
  //   data: {
  //     label: 'Gênero',
  //     icon: 'gender',
  //     options: [
  //       {
  //         label: 'Informe seu gênero',
  //         value: '',
  //       },
  //       {
  //         label: 'Homem',
  //         value: 'MALE',
  //       },
  //       {
  //         label: 'Mulher',
  //         value: 'FEMALE',
  //       },
  //       {
  //         label: 'Não informado',
  //         value: 'NOT_INFORMED',
  //       },
  //       {
  //         label: 'Outro',
  //         value: 'OTHER',
  //       },
  //     ],
  //   },
  //   html: {},
  // },
]

export default fields
